// extracted by mini-css-extract-plugin
export default {"create-answer-body":"CreateAnswer_create-answer-body__3cTO+","editor":"CreateAnswer_editor__2fPSH","loading-value":"CreateAnswer_loading-value__VJD8U"};